import { render, staticRenderFns } from "./TipsSlider.vue?vue&type=template&id=03293fa9&scoped=true&"
import script from "./TipsSlider.vue?vue&type=script&lang=ts&"
export * from "./TipsSlider.vue?vue&type=script&lang=ts&"
import style0 from "./TipsSlider.vue?vue&type=style&index=0&id=03293fa9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03293fa9",
  null
  
)

export default component.exports